import * as React from "react";
import Svg, { SvgProps, Mask, Path } from "react-native-svg";

const TabBenefitsIcon = ({ color, ...props }: SvgProps) => (
  <Svg width={25} height={24} fill="none" {...props}>
    <Mask id="benefits-mask" fill="#fff">
      <Path d="M4.23 20.123a.968.968 0 0 1-.643-.238.772.772 0 0 1-.267-.575V2.25H1.5v17.06c0 .647.288 1.268.8 1.725a2.903 2.903 0 0 0 1.93.715h19.11v-1.627H4.23Z" />
    </Mask>
    <Path
      fill={color}
      d="M4.23 20.123a.968.968 0 0 1-.643-.238.772.772 0 0 1-.267-.575V2.25H1.5v17.06c0 .647.288 1.268.8 1.725a2.903 2.903 0 0 0 1.93.715h19.11v-1.627H4.23Z"
    />
    <Path
      fill={color}
      d="M3.32 19.31h-21.333H3.32Zm0-17.06h21.333v-21.333H3.32V2.25Zm-1.82 0v-21.333h-21.333V2.25H1.5Zm0 17.06h-21.333H1.5Zm2.73 2.44v21.333V21.75Zm19.11 0v21.333h21.333V21.75H23.34Zm0-1.627h21.333V-1.21H23.34v21.333ZM4.23-1.21c4.691 0 9.606 1.644 13.573 5.189L-10.63 35.79a22.3 22.3 0 0 0 14.86 5.666V-1.21Zm13.573 5.189a20.562 20.562 0 0 1 6.85 15.331h-42.666c0 6.696 2.997 12.561 7.383 16.481L17.803 3.98ZM3.32-19.083H1.5v42.666h1.82v-42.666ZM-19.833 2.25v17.06h42.666V2.25h-42.666Zm0 17.06c0 7.128 3.189 13.406 7.916 17.632L16.516 5.129a19.02 19.02 0 0 1 6.317 14.181h-42.666Zm7.916 17.632c4.65 4.155 10.49 6.141 16.147 6.141V.417c4.209 0 8.66 1.472 12.286 4.712l-28.433 31.813ZM4.23 43.083h19.11V.417H4.23v42.666ZM44.673 21.75v-1.627H2.007v1.627h42.666ZM23.34-1.21H4.23v42.667h19.11V-1.21Zm1.313 20.52v-8.53h-42.666v8.53h42.666Zm0-8.53V2.25h-42.666v8.53h42.666Z"
      mask="url(#benefits-mask)"
    />
    <Path
      fill={color}
      d="M7.239 12.1H5.822v5.165H7.24v-5.164ZM10.78 10.625H9.363v6.64h1.417v-6.64ZM14.321 12.839h-1.417v4.427h1.417v-4.427ZM17.864 9.888h-1.417v7.378h1.417V9.888ZM21.386 8.406h-1.415v8.846h1.415V8.406ZM10.072 6.504l3.542 3.689 5.459-5.687-1.002-1.043-4.458 4.643-3.541-3.69-4.043 4.212L7.031 9.67l3.04-3.167Z"
    />
    <Path fill={color} fillRule="evenodd" d="M18.378 4.168h-2.653V3.062h3.715v3.87h-1.062V4.168Z" clipRule="evenodd" />
  </Svg>
);
export default TabBenefitsIcon;
